export enum ProjectType {
  value = 'value',
  number = 'number',
}
